var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBold01 = function SvgBold01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.105 3.037c1.389 0 2.621.44 3.685 1.317 1.079.89 1.62 2.057 1.62 3.476 0 .946-.248 1.785-.753 2.506a4.6 4.6 0 0 1-1.332 1.287q.999.44 1.733 1.38c.63.81.942 1.784.942 2.905 0 1.569-.592 2.82-1.776 3.723-1.159.883-2.442 1.329-3.842 1.329H5.999V3.037zM8.294 18.791h4.003c1.022 0 1.824-.305 2.43-.898.617-.604.916-1.294.917-2.08 0-.787-.3-1.478-.917-2.082-.606-.592-1.415-.899-2.454-.899H8.294zm0-8.097h3.726c.868 0 1.59-.266 2.181-.793.587-.523.877-1.17.877-1.959 0-.803-.295-1.452-.89-1.963-.604-.52-1.317-.78-2.15-.78H8.293z",
    clipRule: "evenodd"
  })));
};
export default SvgBold01;